import { API } from '@/utils'

export default {
    state: {
        clinicTypes: []
    },
    mutations: {
        LOAD_CLINIC_TYPES(state, payload) {
            state.clinicTypes = payload
        }
    },
    actions: {
        LOAD_CLINIC_TYPES({ commit, getters }) {
            return new Promise((resolve, reject) => {
                API.get('/clinictypes')
                .then( response => {
                    commit('LOAD_CLINIC_TYPES', response.data)
                    resolve()
                })
                .catch(e => {
                    throw e
                    reject(e)
                })
            })
        }
    },
    getters: {
        GET_ALL_CLINIC_TYPES(state) {
            return state.clinicTypes
        }
    }
}